import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { BlockList } from "@/components/blocks/block-list";
import { ScanBlockButton } from "@/components/blocks/scan-block-button";
import { UnlinkedShiftList } from "@/components/shifts/unlinked-shift-list";
import { ExpenseList } from "@/components/expenses/expense-list";
import { DollarSign, Car, Receipt } from "lucide-react";

export default function BlocksPage() {
  return (
    <div className="container mx-auto px-4 py-8 max-w-2xl">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">History</h1>
        <ScanBlockButton variant="outline" size="sm" />
      </div>

      <Tabs defaultValue="blocks" className="w-full">
        <TabsList className="grid w-full grid-cols-3 mb-6">
          <TabsTrigger value="blocks" className="flex items-center gap-2">
            <DollarSign className="h-4 w-4" />
            Blocks
          </TabsTrigger>
          <TabsTrigger value="commutes" className="flex items-center gap-2">
            <Car className="h-4 w-4" />
            Commutes
          </TabsTrigger>
          <TabsTrigger value="expenses" className="flex items-center gap-2">
            <Receipt className="h-4 w-4" />
            Expenses
          </TabsTrigger>
        </TabsList>

        <TabsContent value="blocks">
          <BlockList />
        </TabsContent>

        <TabsContent value="commutes">
          <UnlinkedShiftList />
        </TabsContent>

        <TabsContent value="expenses">
          <ExpenseList />
        </TabsContent>
      </Tabs>
    </div>
  );
}
